import { getUrlPropertyType } from "./getUrlPropertyType";
import { getWaiveEscrow } from "./getWaiveEscrow";
import { getLoanOptionParams } from "./getLoanOptionParams";
import { getUsCitizenType } from "./getUsCitizenType";
import { getSelfEmployedParam } from "./getSelfEmployedParam";
import { getOccupancyTypeParam } from "./getOccupancyTypeParam";
import { getLoanPurposeParam } from "./getLoanPurposeParam";
import { getTrueFalse } from "./getTrueFalse";
import { getCashOutAmountParam } from "./getCashOutAmountParam";
import { getIsConstruction } from "./getIsConstruction";
import { getRateLockPeriod } from "./getRateLockPeriod";
import { getRefinanceLoanAmount } from "./getRefinanceLoanAmount";
import { getVeteranType } from "./getveteranType";

export const getRefinanceParameterizedQuoteEndpoint = ({
  baseUrl,
  data: {
    amountOfCashOut,
    city,
    county,
    creditScore,
    existingLoanBalance,
    hasWaivedEscrow,
    isSelfEmployed,
    isUsCitizen,
    lookAtVaLoans,
    loanOptions,
    occupancyType,
    price,
    propertyType,
    state,
    street,
    zip,
    neighborhood,
    vaFirstTimeUse,
    disabledVeteran,
    veteranType,
  },
  lookingTo,
}) => {
  const urlPropertyType = getUrlPropertyType(propertyType);
  const loanAmount = getRefinanceLoanAmount(
    lookingTo,
    existingLoanBalance,
    amountOfCashOut
  );
  const waiveEscrow = getWaiveEscrow(hasWaivedEscrow);
  const loanOptionParams = getLoanOptionParams(loanOptions);
  const usCitizenType = getUsCitizenType(isUsCitizen);
  const selfEmployedParam = getSelfEmployedParam(isSelfEmployed);
  const occupancyTypeParam = getOccupancyTypeParam(occupancyType);
  const rateLockPeriod = 30;
  const loanPurposeParam = getLoanPurposeParam(lookingTo, amountOfCashOut);
  const lookAtVaLoansParam = getTrueFalse(lookAtVaLoans);
  const vaFirstTimeUseParam = getTrueFalse(vaFirstTimeUse);
  const disabledVeteranParam = getTrueFalse(disabledVeteran);
  // you're refinancing your home. You therefore cannot be a first time home buyer
  const firstTimeBuyer = "false";
  const cashOutAmountParam = getCashOutAmountParam(lookingTo, amountOfCashOut);
  const isConstruction = getIsConstruction();
  const veteranTypeParam = getVeteranType(veteranType);

  if (loanOptionParams?.ARM?.length) {
    baseUrl.searchParams.append("amortizationTypes", "ARM");
    if (loanOptionParams.ARM.includes("FiveYear"))
      baseUrl.searchParams.append("armFixedTerms", "FiveYear");
    if (loanOptionParams.ARM.includes("SevenYear"))
      baseUrl.searchParams.append("armFixedTerms", "SevenYear");
    if (loanOptionParams.ARM.includes("TenYear"))
      baseUrl.searchParams.append("armFixedTerms", "TenYear");
  }
  if (loanOptionParams?.Fixed?.length) {
    baseUrl.searchParams.append("amortizationTypes", "Fixed");
    if (loanOptionParams.Fixed.includes("TenYear"))
      baseUrl.searchParams.append("loanTerms", "TenYear");
    if (loanOptionParams.Fixed.includes("FifteenYear"))
      baseUrl.searchParams.append("loanTerms", "FifteenYear");
    if (loanOptionParams.Fixed.includes("TwentyYear"))
      baseUrl.searchParams.append("loanTerms", "TwentyYear");
    if (loanOptionParams.Fixed.includes("ThirtyYear"))
      baseUrl.searchParams.append("loanTerms", "ThirtyYear");
  }

  baseUrl.searchParams.append("cashOutAmount", cashOutAmountParam);
  baseUrl.searchParams.append("citizenType", usCitizenType);
  baseUrl.searchParams.append("city", city);
  baseUrl.searchParams.append("county", county);
  baseUrl.searchParams.append("neighborhood", neighborhood);
  baseUrl.searchParams.append("creditScore", creditScore);
  baseUrl.searchParams.append("firstTimeBuyer", firstTimeBuyer);
  baseUrl.searchParams.append("loanAmount", loanAmount);
  baseUrl.searchParams.append("loanPurpose", loanPurposeParam);
  baseUrl.searchParams.append("lockDays", rateLockPeriod);
  baseUrl.searchParams.append("lookAtVaLoans", lookAtVaLoansParam);
  baseUrl.searchParams.append(
    "vaFirstTimeUse",
    lookAtVaLoansParam === "true" ? "true" : vaFirstTimeUseParam
  );
  baseUrl.searchParams.append("disabledVeteran", disabledVeteranParam);
  baseUrl.searchParams.append("isConstruction", isConstruction);
  baseUrl.searchParams.append("occupancyType", occupancyTypeParam);
  baseUrl.searchParams.append("propertyType", urlPropertyType);
  baseUrl.searchParams.append("propertyValue", price);
  baseUrl.searchParams.append("streetAddress", street);
  baseUrl.searchParams.append("state", state);
  baseUrl.searchParams.append("selfEmployed", selfEmployedParam);
  baseUrl.searchParams.append("veteranType", veteranTypeParam);
  baseUrl.searchParams.append("waiveEscrow", waiveEscrow);
  baseUrl.searchParams.append("zipCode", zip);

  return baseUrl;
};
